import api from "./apiSmartLogistics.js";

export default {
  GetClientsSearch(searchItem) {
    return api.post("InsertOrder/GetClients", searchItem);
  },
  GetClients(id) {
    return api.get("InsertOrder/GetClients/" + id);
  },
  GetArticleCode() {
    return api.get("InsertOrder/GetArticleCode");
  },
  GetDescription() {
    return api.get("InsertOrder/GetDescription");
  },
  GetNations(nations) {
    return api.get("InsertOrder/GetNations/" + nations);
  },
  GetTypeOrder(id) {
    return api.get("InsertOrder/GetTypeOrder/" + id);
  },
  GetPort(id) {
    return api.get("InsertOrder/GetPort/" + id);
  },
  GetTransportCasual(id) {
    return api.get("InsertOrder/GetTransportCasual/" + id);
  },
  GetCarrier(id) {
    return api.get("InsertOrder/GetCarrier/" + id);
  },
  GetArticle(id) {
    return api.get("InsertOrder/GetArticle/" + id);
  },
  InsertOrder(io) {
    return api.post("InsertOrder/InsertOrder", io);
  }
};
